import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from '@mui/material';
import styled from '@emotion/styled';
// withWidth removed - use useMediaQuery instead;
import { findIndex } from 'lodash';
import { theme } from '../../../themes/default-theme';
import cube from '../../../assets/icons/cube.svg';
import RadioCheck from '../../../assets/icons/radio-button.svg';
import RadioCheckMobile from '../../../assets/icons/radio-button-mobile.svg';
import TabsCurvedMobile from '../TabsCurved/Dropdown';

const TabsContainer = styled(props => {
  return <Tabs {...props} />
})`
  &:hover: {
    outline: 'none',
  }
  & .MuiTabs-indicator {
    background: none;
  }
  & .MuiTabs-flexContainer {
    display: block;
  }
  &.socials {
    max-width: 480px;
    margin: 52px auto;
  }

`;

const TabSelect = styled(props => {
  return <Tab {...props} classes={{ selected: 'selected' }} />
})`
  & {
    font-size: 17px;
    line-height: 23px;
    padding: 0 18px;
    display: block;
    text-align: left;
    width: 100%;
    max-width: 100%;
    color: ${theme.palette.gunmentalGrey};
    background : ${theme.palette.white};
    border-radius: 8px;
    border: 1px solid #DCDCDC;
    text-transform: capitalize;
    font-weight: 400;
    min-width: 85px;
    opacity: 1;
    margin: 0 0 12px;
    display: flex;
    flex-direction: row;
    gap: 16px;
    justify-content: flex-start;
    > span:first-child {
      display: flex;
      flex-direction: revert;
      justify-content: flex-start;
      position: relative;
    }
   
      &:before {
        content: "";
        font-size: 1rem;
        display: inline-block;
        background: inherit;
        border: 1px solid #979797;
        border-radius: 59px;
      }
    
    ${theme.breakpoints.up("md")} {
      min-height: 50px;
      height: 50px;
     
        gap: 16px;
        &:before {
          width: 25px;
          height: 25px;
        }
      
    }
    ${theme.breakpoints.down("sm")} {
      min-height: 42px;
      height: 42px;
      font-size: 12px;
      line-height: 16px;
        gap: 8px;
        &:before {
          width: 19px;
          height: 19px;
        }
        
    }
    
    ${props => props.background == 'dark' && `
      color: ${theme.palette.white};
      background: #292929;
      border: 1px solid #575757;
    `}
  }

  &.selected {
    border: 2px solid ${theme.palette.vividBlue};
    border-radius: 8px;
    color: rgb(117, 128, 148);
  
      &:before {
        background: #0170D4;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        ${theme.breakpoints.up('md')} {
            content: url(${RadioCheck});
          }
        ${theme.breakpoints.down('sm')} {
            content: url(${RadioCheckMobile});
        }
      }
    
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  ${props => props.tour == 1 && `
    padding-left: 46px !important;

    &:before {
      content: '';
      width: 17px;
      height: 20px;
      background-color: ${theme.palette.gunmentalGrey};
      -webkit-mask-image: url(${cube});
      mask-image: url(${cube});
      mask-size: contain;
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);

      ${props => props.background == 'dark' && `
        background-color: ${theme.palette.white};
      `}
    }
  `}
`;

export const FloorplanOptions = props => {
  const [value, setValue] = React.useState(props.activeIndex);
  const {
    data,
    variant,
    width,
    neverNative,
    activeMobileLength,
    background
  } = props;

  useEffect(() => {
    setValue(props.activeIndex);
  }, [props.activeIndex]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    props.onChange(newValue);
  };

  const mobileDropdownValue = data[value]

  return (
    <TabsContainer
      value={value}
      onChange={handleChange}
      variant={variant}
      centered={true}
    >
      {data &&
   
          data.map(function(tab, index) {
            return (
              <TabSelect
                key={tab.id || index}
                label={<span>{tab.title}</span>}
                tour={tab.tour ? 1 : 0}
                background={background}
                
              />
            )
          })
        }
    </TabsContainer>
  );
}

FloorplanOptions.propTypes = {
  data: PropTypes.array,
  variant: PropTypes.string,
  onChange: PropTypes.func,
  active: PropTypes.string,
  activeIndex: PropTypes.number,
  neverNative: PropTypes.bool,
  activeMobileLength: PropTypes.number,
  background: PropTypes.string
};

FloorplanOptions.defaultProps = {
  variant: 'fullWidth',
  onChange: () => { },
  activeIndex: 0,
  active: null,
  neverNative: false,
  activeMobileLength: 2,
  background: null
};

export default (FloorplanOptions);
